import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";

import { UserAccount } from "./user";
import { defaultGenericMeta, GenericStateMeta } from "store/common";
import {
  attachAccount,
  createUserAccount,
  fetchUserAccount,
  updateUserAccount,
} from "./user-action";

export interface UserState {
  user?: UserAccount;
  meta: GenericStateMeta;
}

const userEntityAdapter = createEntityAdapter<UserAccount>({});

export const userSlice = createSlice({
  name: "user",
  initialState: userEntityAdapter.getInitialState<UserState>({
    meta: { ...defaultGenericMeta },
  }),
  reducers: {
    setUser(state, action: PayloadAction<UserAccount>) {
      state.user = {
        ...action.payload,
      };
    },
    resetUser(state) {
      delete state.user;
      state.meta = { ...defaultGenericMeta };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createUserAccount.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(createUserAccount.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
    builder.addCase(
      updateUserAccount.fulfilled,
      (state, { payload }: PayloadAction<UserAccount>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        state.user = payload;
      }
    );
    builder.addCase(updateUserAccount.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(updateUserAccount.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
    builder.addCase(
      fetchUserAccount.fulfilled,
      (state, { payload }: PayloadAction<UserAccount>) => {
        state.meta.isLoading = false;
        state.meta.isSuccess = true;
        state.meta.status = "idle";
        state.user = payload;
      }
    );
    builder.addCase(attachAccount.pending, (state) => {
      state.meta.isLoading = true;
      state.meta.status = "inProcess";
    });
    builder.addCase(attachAccount.rejected, (state) => {
      state.meta.isLoading = false;
      state.meta.status = "idle";
      state.meta.error = "true";
    });
    builder.addCase(PURGE, () => {
      return userEntityAdapter.getInitialState({
        meta: { ...defaultGenericMeta },
      });
    });
  },
});

export const { setUser, resetUser } = userSlice.actions;
export default userSlice.reducer;
